import { AddTrainingEventRequest } from './add.training.event.request';
import { UpdateTrainingEventSubscriptionRequestArray } from './update.training.event.subscription.request';

export class UpdateTrainingEventRequest extends AddTrainingEventRequest {
    TrainingEventID: number;
    ExistingAttendees: UpdateTrainingEventSubscriptionRequestArray;
}
